import axios from 'axios'
import Loading from 'muse-ui-loading'
import { SIGN_KEY } from '@/config/consts.js'
// import dayjs from "dayjs";
import md5 from 'blueimp-md5'

const isProduction = process.env.NODE_ENV === 'production'

const baseURL = isProduction
  ? window.STATIC_CONFIG.host
  : window.STATIC_CONFIG.test
// const baseURL = isProduction
// ? window.STATIC_CONFIG.host
// : 'http://dingxiang.yocent.cn:8888/'

// 创建axios实例
const service = axios.create({
  // 测试服务器
  baseURL,
  // 请求超时时间
  timeout: 15000,
  // headers: {
  // },
})

var loading
var loadingCount = (window.loadingCount = 0)

function closeLoading(noLoading) {
  if (noLoading) return
  loadingCount--
  if (loadingCount <= 0 && loading) {
    loading.close()
    loading = null

    // 尽可能的增加容错率
    if (loadingCount < 0) {
      console.error('utils/request.js LoadingCount < 0: ', loadingCount)
      loadingCount = 0
    }
  }
}
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (!config.noFullScreenLoading && !loading) {
      loading = Loading()
    }
    if (!config.noFullScreenLoading) {
      loadingCount++
    }
    const isUploadRequest = Boolean(config.formData)
    // 根据是否是文件上传获取对应的 data 字段
    let dataKeyName = isUploadRequest ? 'formData' : 'data'
    const formdata = new FormData()
    let time = new Date()
    time = (time.getTime() / 1000).toFixed(0)
    if (isUploadRequest) {
      formdata.append('platform', 'signup')
      formdata.append('time', time)
      if (config.upload_type) {
        formdata.append('upload_type', config.upload_type)
      }
      for (let file of config[dataKeyName]) {
        formdata.append(config.name, file)
      }
      // 生成签名
      const sign = generateSign({
        time,
        platform: 'signup',
        upload_type: config.upload_type || null,
      })

      formdata.append('sign', sign)
      config.data = formdata
    } else {
      // 生成签名
      const sign = generateSign({
        ...config[dataKeyName],
        time,
        platform: 'signup',
      })
      config[dataKeyName].sign = sign
      config[dataKeyName].time = time
      config[dataKeyName].platform = 'signup'
    }

    config.data = formdata
    return config
  },
  (error) => {
    // Do something with request error
    console.error('interceptors::', error) // for debug
    window.vm.$NewToast.error(error, 2000)
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const data = response.data
    closeLoading(response.config.noFullScreenLoading)

    if (data.status !== 1) {
      console.log(
        'service.interceptors.response: ',
        response,
        response.config.url,
        response.config.noToast
      )
      if (!response.config.noToast) {
        window.vm.$NewToast.info(data.error, 1500)
      }
      return Promise.reject(data)
    } else {
      return data
    }
  },
  (error) => {
    console.error('interceptors::', error)
    window.vm.$NewToast.error(error.response.data.error, 2000)
    setTimeout(() => {
      closeLoading()
    }, 800)
    return Promise.reject(error)
  }
)

/**
 * 生成sign
 * @param {object} params get的query参数， post的query、body参数
 */
function generateSign(params) {
  // 签名的key
  const signKey = SIGN_KEY
  let keyArrSort = Object.keys(params).sort()
  let sign = ''
  keyArrSort.map((key) => {
    let val = params[key]
    if (
      val !== '' &&
      val !== null &&
      val !== undefined &&
      typeof val !== 'object' &&
      typeof val !== 'boolean'
    ) {
      sign += `${key}=${val}&`
    }
  })
  if (sign.substr(-1) == '&') {
    sign = sign.substring(0, sign.length - 1)
  }
  sign = sign + signKey
  return md5(sign)
}

export default service
